import { gql } from '@apollo/client'

import { MutationService, getMutationService } from '../../../../helpers/GraphqlHelpers'
import { VerifyTwoFactorMutation } from '../../../generated/graphql'
import { UserFragment } from '../../../fragments'

export const verifyTwoFactor: MutationService = getMutationService({
  mutation: gql`
    mutation verifyTwoFactor($email: String!, $code: String!) {
      verifyTwoFactor(email: $email, code: $code) {
        token
        email
        firstName
        lastName
        ...UserFragment
      }
    }
    ${UserFragment}
  `,
  transformer: (response: VerifyTwoFactorMutation) => {
    return response.verifyTwoFactor
  },
})
